// extracted by mini-css-extract-plugin
export default {"logosTitle":"UploadLogos_logosTitle__+tbY3"};